import { ReactElement } from "react";
import $i18n from "@ali/flute-i18n";
import * as React from "react";

export const IconMap = {
  error: (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="8344"
    >
      <path
        d="M764.8 727.04l-24.96 11.52 46.08 97.28 24.96-11.52-46.08-97.28zM268.8 727.04l24.96 11.52-46.08 97.28-24.96-11.52 46.08-97.28zM699.52 662.4c0 7.68-6.4 13.44-13.44 13.44-7.68 0-13.44-6.4-13.44-13.44 0-7.68 6.4-13.44 13.44-13.44 7.68-0.64 13.44 5.76 13.44 13.44zM522.24 706.56c0 7.68-6.4 13.44-13.44 13.44s-13.44-6.4-13.44-13.44 6.4-13.44 13.44-13.44 13.44 5.76 13.44 13.44zM334.72 662.4c0 7.68-6.4 13.44-13.44 13.44s-13.44-6.4-13.44-13.44c0-7.68 6.4-13.44 13.44-13.44s13.44 5.76 13.44 13.44z"
        fill="#6B5FF2"
        p-id="8345"
      ></path>
      <path
        d="M645.12 556.16v-3.2c0-8.96-0.64-17.28-2.56-25.6 112 21.76 190.08 71.04 190.08 128 0 77.44-143.36 140.16-320.64 140.16-177.28 0-320.64-62.72-320.64-140.16 0-54.4 71.68-101.76 176-124.8-1.28 7.04-1.92 14.72-1.92 22.4v5.76c-25.6 6.4-49.28 13.44-69.12 22.4-26.88 11.52-47.36 24.96-60.16 38.4s-17.28 24.96-17.28 35.2 4.48 22.4 17.28 35.2c12.8 13.44 33.28 26.88 60.16 38.4 53.76 23.68 129.92 38.4 215.68 38.4s161.92-15.36 215.68-38.4c26.88-11.52 47.36-24.96 60.16-38.4s17.28-24.96 17.28-35.2-4.48-22.4-17.28-35.2c-12.8-13.44-33.28-26.88-60.16-38.4-23.68-10.24-51.2-18.56-82.56-24.96z"
        fill="currentColor"
        p-id="8346"
      ></path>
      <path
        d="M504.96 412.8C427.52 412.8 364.8 475.52 364.8 552.96c0 77.44 62.72 105.6 140.16 105.6 77.44 0 140.16-28.8 140.16-105.6 0-77.44-62.72-140.16-140.16-140.16zM588.8 611.84c-19.2 12.8-48 19.2-83.84 19.2s-64.64-7.04-83.84-19.2c-17.28-11.52-28.8-29.44-28.8-58.88 0-62.08 50.56-112.64 112.64-112.64s112.64 50.56 112.64 112.64c0 30.08-11.52 47.36-28.8 58.88z"
        fill="currentColor"
        p-id="8347"
      ></path>
    </svg>
  ),
  error404: (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="8487"
    >
      <path
        d="M505.6 375.68c-36.48 0-65.28 35.2-65.28 78.72S469.76 533.12 505.6 533.12c36.48 0 65.28-35.2 65.28-78.72S542.08 375.68 505.6 375.68z m0 130.56c-16.64 0-38.4-17.92-38.4-51.84s21.76-51.84 38.4-51.84 38.4 17.92 38.4 51.84-21.76 51.84-38.4 51.84zM341.76 375.68H371.2V486.4h26.24v27.52H371.2v24.96h-27.52v-24.96H263.04l78.72-138.24z m1.92 110.72v-59.52L310.4 486.4h33.28zM683.52 375.68h29.44V486.4h26.24v27.52h-26.24v24.96h-27.52v-24.96H604.8l78.72-138.24z m1.92 110.72v-59.52l-33.92 59.52h33.92z"
        fill="#6B5FF2"
        p-id="8488"
      ></path>
      <path
        d="M853.12 283.52H170.88v348.16H249.6V819.2h33.92V631.68h457.6V819.2h33.92V631.68h78.72V283.52z m-26.88 320.64H197.76V310.4H825.6v293.76z"
        fill="currentColor"
        p-id="8489"
      ></path>
    </svg>
  ),
  errorNetwork: (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="8629"
    >
      <path
        d="M498.56 498.56h27.52v330.88h-27.52V498.56z"
        fill="currentColor"
        p-id="8630"
      ></path>
      <path
        d="M512 378.88c-37.76 0-68.48 30.72-68.48 68.48 0 37.76 30.72 68.48 68.48 68.48 37.76 0 68.48-30.72 68.48-68.48 0-37.76-30.72-68.48-68.48-68.48z m0 109.44c-22.4 0-40.96-18.56-40.96-40.96 0-22.4 18.56-40.96 40.96-40.96 22.4 0 40.96 18.56 40.96 40.96 0 22.4-18.56 40.96-40.96 40.96z"
        fill="currentColor"
        p-id="8631"
      ></path>
      <path
        d="M734.72 642.56c108.16-108.8 108.16-285.44 0-393.6l19.2-19.2c119.04 119.04 119.04 312.96 0 432.64l-19.2-19.84z"
        fill="#6B5FF2"
        p-id="8632"
      ></path>
      <path
        d="M638.72 590.72c81.28-81.28 81.28-213.76 0-294.4l19.2-19.2c91.52 91.52 91.52 241.28 0 333.44l-19.2-19.84zM303.36 642.56c-108.16-108.8-108.16-285.44 0-393.6l-19.2-19.2c-119.04 119.04-119.04 312.96 0 432.64l19.2-19.84z"
        fill="#6B5FF2"
        p-id="8633"
      ></path>
      <path
        d="M398.72 590.72c-81.28-81.28-81.28-213.76 0-294.4l-19.2-19.2C288 368.64 288 518.4 379.52 610.56l19.2-19.84z"
        fill="#6B5FF2"
        p-id="8634"
      ></path>
    </svg>
  ),
  errorWishlist: (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="8774"
    >
      <path
        d="M295.68 381.44c53.12-53.12 138.88-53.12 192 0l24.32 24.32 23.68-23.04c53.12-53.12 138.88-53.12 192 0s53.12 138.88 0 192l-160 160-23.04-23.04 160-160c40.32-40.32 40.32-106.24 0-146.56-40.32-40.32-106.24-40.32-146.56 0l-46.72 44.8-46.72-46.72c-40.32-40.32-106.24-40.32-146.56 0s-40.32 106.24 0 146.56l216.32 217.6-23.04 23.04-216.32-217.6c-52.48-52.48-52.48-138.88 0.64-191.36z"
        fill="currentColor"
        p-id="8775"
      ></path>
      <path
        d="M525.44 170.88v95.36h-27.52V170.88h27.52zM666.88 204.8l-44.16 76.8-23.68-13.44 44.16-76.8 23.68 13.44zM387.2 191.36l44.16 76.8-23.04 13.44-44.16-76.8 23.04-13.44z"
        fill="#6B5FF2"
        p-id="8776"
      ></path>
    </svg>
  ),
  errorPay: (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="8916"
    >
      <path
        d="M228.48 368.64h556.16v27.52H228.48v-27.52zM279.68 542.72H358.4v27.52H279.68v-27.52zM279.68 464h296.96v27.52H279.68v-27.52z"
        fill="currentColor"
        p-id="8917"
      ></path>
      <path
        d="M232.32 296.96h549.76v132.48c9.6 2.56 18.56 6.4 27.52 10.24V269.44H204.8v423.04h394.88c-6.4-8.32-12.16-17.92-16.64-27.52H232.32V296.96z"
        fill="currentColor"
        p-id="8918"
      ></path>
      <path
        d="M735.36 440.32c-81.92 0-147.84 66.56-147.84 147.84 0 81.92 66.56 147.84 147.84 147.84 81.92 0 147.84-66.56 147.84-147.84 0-81.28-65.92-147.84-147.84-147.84z m0 268.8c-66.56 0-120.96-53.76-120.96-120.96 0-66.56 54.4-120.96 120.96-120.96 66.56 0 120.96 53.76 120.96 120.96-0.64 67.2-54.4 120.96-120.96 120.96z"
        fill="#6B5FF2"
        p-id="8919"
      ></path>
      <path
        d="M720 512h27.52v95.36h-27.52V512zM747.52 638.08c0 7.68-6.4 13.44-13.44 13.44-7.68 0-13.44-6.4-13.44-13.44 0-7.68 6.4-13.44 13.44-13.44s13.44 6.4 13.44 13.44z"
        fill="#6B5FF2"
        p-id="8920"
      ></path>
    </svg>
  ),
  voucherExpired: (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="9060"
    >
      <path
        d="M170.88 218.24h182.4v27.52H197.76v136.32c20.48 12.8 37.12 30.72 49.28 51.84 13.44 23.04 20.48 49.92 20.48 76.8s-7.04 53.12-20.48 76.8c-12.16 21.12-29.44 39.04-49.28 51.84v136.32h625.28V639.36c-20.48-12.8-37.12-30.72-49.28-51.84-13.44-23.04-20.48-49.92-20.48-76.8s7.04-53.12 20.48-76.8c12.16-21.12 28.8-38.4 49.28-51.84V245.76H397.44v-27.52h452.48v179.2l-7.04 3.84c-19.2 10.88-35.2 26.88-46.08 46.08-10.88 19.2-16.64 40.96-16.64 62.72 0 21.76 5.76 43.52 16.64 62.72 10.88 19.2 26.88 35.2 46.08 46.08l7.04 3.84v179.2H170.88v-179.2l7.04-3.84c19.2-10.88 35.2-26.88 46.08-46.08 10.88-19.2 16.64-40.96 16.64-62.72 0-21.76-5.76-43.52-16.64-62.72-10.88-19.2-26.88-35.2-46.08-46.08l-7.04-3.84v-179.2z"
        fill="currentColor"
        p-id="9061"
      ></path>
      <path
        d="M513.28 365.44c-81.92 0-147.84 66.56-147.84 147.84 0 81.92 66.56 147.84 147.84 147.84 81.92 0 147.84-66.56 147.84-147.84 0-81.92-65.92-147.84-147.84-147.84z m0 268.8c-66.56 0-120.96-53.76-120.96-120.96 0-66.56 53.76-120.96 120.96-120.96 66.56 0 120.96 53.76 120.96 120.96 0 66.56-54.4 120.96-120.96 120.96z"
        fill="#6B5FF2"
        p-id="9062"
      ></path>
      <path
        d="M498.56 440.32h27.52v95.36h-27.52V440.32zM525.44 566.4c0 7.68-6.4 13.44-13.44 13.44s-13.44-6.4-13.44-13.44 6.4-13.44 13.44-13.44 13.44 6.4 13.44 13.44z"
        fill="#6B5FF2"
        p-id="9063"
      ></path>
    </svg>
  ),
  voucherEmpty: (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="9203"
    >
      <path
        d="M172.16 219.52h33.28v27.52h-5.76v5.76h-27.52v-33.28z m71.68 0h39.04v27.52h-39.04v-27.52z m78.08 0h39.04v27.52h-39.04v-27.52z m77.44 0h40.32v27.52h-40.32v-27.52z m82.56 0h42.24v27.52h-42.24v-27.52z m83.84 0H608v27.52h-42.24v-27.52z m83.84 0h42.24v27.52h-42.24v-27.52z m83.84 0h42.24v27.52h-42.24v-27.52z m83.84 0h34.56v33.28h-27.52v-5.76h-7.04v-27.52zM172.16 332.16v-39.68h27.52v39.68h-27.52z m679.68-39.68v39.68h-27.52v-39.68h27.52zM172.16 371.84h27.52V384c3.2 1.92 6.4 4.48 9.6 7.04l-16.64 21.76c-4.48-3.2-8.96-6.4-13.44-8.96l-7.04-3.84v-28.16z m679.68 0v27.52l-7.04 3.84c-4.48 2.56-9.6 5.76-13.44 8.96l-16.64-21.76c3.2-2.56 6.4-4.48 9.6-7.04V371.2h27.52zM225.28 449.28c-2.56-4.48-5.76-9.6-8.96-13.44l21.76-16.64c3.84 5.12 7.68 10.88 10.88 16.64 3.2 5.76 6.4 11.52 8.96 17.92l-24.96 10.24c-2.56-5.12-5.12-10.24-7.68-14.72z m582.4-14.08c-3.2 4.48-6.4 8.96-8.96 13.44-2.56 4.48-5.12 9.6-7.04 14.72l-24.96-10.24c2.56-6.4 5.76-12.16 8.96-17.92 3.2-5.76 7.04-11.52 10.88-16.64l21.12 16.64z m-24.96 60.16c-0.64 5.12-1.28 10.88-1.28 16.64 0 5.76 0.64 10.88 1.28 16.64l-26.88 3.2c-0.64-6.4-1.28-13.44-1.28-19.84s0.64-13.44 1.28-19.84l26.88 3.2zM241.92 512c0-5.76-0.64-10.88-1.28-16.64l26.88-3.2c0.64 6.4 1.28 13.44 1.28 19.84m522.88 48c1.92 5.12 4.48 10.24 7.04 14.72 2.56 4.48 5.76 9.6 8.96 13.44l-21.76 16.64c-3.84-5.12-7.68-10.88-10.88-16.64-3.2-5.76-6.4-11.52-8.96-17.92l25.6-10.24z m-566.4 14.72c2.56-4.48 5.12-9.6 7.04-14.72l24.96 10.24c-2.56 6.4-5.76 12.16-8.96 17.92-3.2 5.76-7.04 11.52-10.88 16.64L216.32 588.8c3.2-4.48 6.4-8.96 8.96-14.08z m606.08 37.12c4.48 3.2 8.96 6.4 13.44 8.96l7.04 3.84v27.52h-27.52V640c-3.2-1.92-6.4-4.48-9.6-7.04l16.64-21.12zM179.2 620.8c4.48-2.56 9.6-5.76 13.44-8.96l16.64 21.76c-3.2 2.56-6.4 4.48-9.6 7.04v12.16h-27.52v-27.52L179.2 620.8z m-7.04 110.72v-39.68h27.52v39.68h-27.52z m679.68-39.68v39.68h-27.52v-39.68h27.52zM172.16 770.56h27.52v5.76h7.04v27.52H172.8v-33.28z m679.68 0v33.28h-33.92v-27.52h7.04v-5.76h26.88zM288 804.48h-40.96v-27.52H288v27.52z m81.28 0h-40.96v-27.52h40.96v27.52z m81.28 0H409.6v-27.52h40.96v27.52z m81.92 0h-40.96v-27.52h40.96v27.52z m81.28 0h-40.96v-27.52h40.96v27.52z m81.92 0h-40.96v-27.52h40.96v27.52z m81.28 0H736v-27.52h40.96v27.52z"
        fill="currentColor"
        p-id="9204"
      ></path>
      <path
        d="M816 126.08c-13.44 0-24.32 10.88-24.32 24.32 0 13.44 10.88 24.32 24.32 24.32 13.44 0 24.32-10.88 24.32-24.32 0-13.44-10.88-24.32-24.32-24.32z m-51.84 24.96c0-28.8 23.04-51.84 51.84-51.84s51.84 23.04 51.84 51.84-23.04 51.84-51.84 51.84-51.84-23.68-51.84-51.84z"
        fill="#6B5FF2"
        p-id="9205"
      ></path>
      <path
        d="M892.8 359.04l-124.16-186.88 23.04-15.36 124.16 186.88-23.04 15.36zM737.92 224.64c-13.44 0-24.32 10.88-24.32 24.32 0 13.44 10.88 24.32 24.32 24.32 13.44 0 24.32-10.88 24.32-24.32 0-13.44-10.88-24.32-24.32-24.32z m-51.84 24.32c0-28.8 23.04-51.84 51.84-51.84s51.84 23.04 51.84 51.84-23.04 51.84-51.84 51.84-51.84-23.04-51.84-51.84z"
        fill="#6B5FF2"
        p-id="9206"
      ></path>
      <path
        d="M947.84 302.72l-208.64-78.08 9.6-25.6 208.64 78.08-9.6 25.6z"
        fill="#6B5FF2"
        p-id="9207"
      ></path>
      <path
        d="M410.24 597.76l184.32-187.52 19.2 19.2-184.32 187.52-19.2-19.2zM576.64 560c-14.72 0-23.68 10.24-23.68 20.48s9.6 20.48 23.68 20.48c14.72 0 23.68-10.24 23.68-20.48 0.64-10.24-8.96-20.48-23.68-20.48z m-51.2 20.48c0-27.52 24.32-48 51.2-48s51.2 20.48 51.2 48-24.32 48-51.2 48c-26.88-0.64-51.2-20.48-51.2-48zM445.44 419.84c-12.16 0-22.4 10.24-22.4 22.4s10.24 22.4 22.4 22.4 22.4-10.24 22.4-22.4-10.24-22.4-22.4-22.4z m-49.28 22.4c0-27.52 22.4-49.28 49.28-49.28 27.52 0 49.28 22.4 49.28 49.28 0 27.52-22.4 49.28-49.28 49.28-27.52 0-49.28-22.4-49.28-49.28z"
        fill="currentColor"
        p-id="9208"
      ></path>
    </svg>
  ),
  SecurityVerification: (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="9348"
    >
      <path
        d="M447.36 228.48c-73.6 0-133.12 58.88-133.12 131.2s59.52 131.2 133.12 131.2 133.12-58.88 133.12-131.2-59.52-131.2-133.12-131.2zM286.72 360.32c0-87.68 71.68-158.72 160.64-158.72C535.68 201.6 608 272.64 608 360.32S535.68 519.04 447.36 519.04C358.4 519.04 286.72 448 286.72 360.32z"
        fill="currentColor"
        p-id="9349"
      ></path>
      <path
        d="M392.32 385.92v-51.2h27.52v51.2h-27.52zM478.08 385.92v-51.2H505.6v51.2h-27.52z"
        fill="#6B5FF2"
        p-id="9350"
      ></path>
      <path
        d="M555.52 563.2c3.84 0 7.68 0 11.52 0.64v27.52c-3.84 0-7.68-0.64-11.52-0.64H339.2c-34.56 0-67.84 13.44-92.16 37.76-21.12 21.12-34.56 48.64-37.76 78.08h357.76v27.52H181.12v-13.44c0-41.6 16.64-81.92 46.08-111.36C256.64 579.84 296.96 563.2 339.2 563.2h216.32z m67.84 162.56l-5.12-4.48v-14.72 14.72l5.12 4.48z m-5.76-142.08v22.4-22.4z"
        fill="currentColor"
        p-id="9351"
      ></path>
      <path
        d="M604.16 570.24h238.72v158.08L723.2 826.88l-119.68-98.56V570.24z m27.52 26.88v117.76l92.16 76.16 92.16-76.16V597.12H631.68z"
        fill="#6B5FF2"
        p-id="9352"
      ></path>
      <path
        d="M728.96 679.68c12.16-12.16 28.16-27.52 40.96-40.32l19.2 19.2c-13.44 13.44-29.44 28.8-41.6 40.96-6.4 5.76-11.52 11.52-15.36 14.72l-4.48 4.48-1.92 1.28-9.6-9.6 9.6 9.6-9.6 8.96-52.48-49.92 18.56-19.84 33.28 32c5.12-3.2 8.96-7.04 13.44-11.52z"
        fill="#6B5FF2"
        p-id="9353"
      ></path>
    </svg>
  ),
  deleteAccount: (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="9493"
    >
      <path
        d="M447.36 208c-73.6 0-133.12 58.88-133.12 131.2s59.52 131.2 133.12 131.2S580.48 411.52 580.48 339.2s-59.52-131.2-133.12-131.2zM286.72 339.84c0-87.68 71.68-158.72 160.64-158.72C535.68 181.12 608 252.16 608 339.84S535.68 498.56 447.36 498.56c-88.96 0-160.64-71.04-160.64-158.72zM574.08 688.64c-0.64 6.4-0.64 12.16 0 18.56 0-3.2-0.64-6.4-0.64-9.6 0-2.56 0-5.76 0.64-8.96z m-33.92 24.96c-0.64-8.96-0.64-18.56 0-27.52H208.64c3.2-29.44 16-56.96 37.76-78.08 24.32-24.32 57.6-37.76 92.16-37.76h216.32c13.44 0 26.88 1.92 39.04 5.76 8.32-7.04 17.28-13.44 26.88-19.2-20.48-9.6-42.88-14.08-65.92-14.08H339.2c-41.6 0-81.92 16.64-112 46.08-29.44 29.44-46.08 69.12-46.08 111.36v13.44h359.04z"
        fill="currentColor"
        p-id="9494"
      ></path>
      <path
        d="M701.44 570.24c-70.4 0-128 57.6-128 128s57.6 128 128 128 128-57.6 128-128c0-71.04-57.6-128-128-128z m0 228.48c-55.68 0-100.48-44.8-100.48-100.48s44.8-100.48 100.48-100.48 100.48 44.8 100.48 100.48-44.8 100.48-100.48 100.48z"
        fill="#6B5FF2"
        p-id="9495"
      ></path>
      <path
        d="M642.56 711.04h115.84v-27.52h-115.84v27.52zM392.32 368.64v-51.2h27.52v51.2h-27.52zM478.08 368.64v-51.2H505.6v51.2h-27.52z"
        fill="#6B5FF2"
        p-id="9496"
      ></path>
    </svg>
  ),
  noSearchResult: (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="9636"
    >
      <path
        d="M732.16 849.92l-112.64-194.56 23.68-13.44 112.64 194.56-23.68 13.44z"
        fill="currentColor"
        p-id="9637"
      ></path>
      <path
        d="M403.84 444.16v-58.88h27.52v58.88h-27.52zM512.64 444.16v-58.88h27.52v58.88h-27.52z"
        fill="#6B5FF2"
        p-id="9638"
      ></path>
      <path
        d="M498.56 184.32c-128 0-232.32 103.68-232.32 232.32 0 128 103.68 232.32 232.32 232.32 128 0 232.32-103.68 232.32-232.32-0.64-128.64-104.32-232.32-232.32-232.32z m0 437.12c-113.28 0-204.8-91.52-204.8-204.8s91.52-204.8 204.8-204.8 204.8 91.52 204.8 204.8c0 112.64-92.16 204.8-204.8 204.8z"
        fill="currentColor"
        p-id="9639"
      ></path>
    </svg>
  ),
  reviewEmpty: (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="9779"
    >
      <path
        d="M704.64 284.16L778.24 358.4l74.24-74.24L758.4 192l-63.36 62.08L512 440.32V531.2h92.16l147.2-144-19.2-19.2-138.88 135.68h-53.76v-52.48l165.12-167.04z m53.76-53.12l55.04 53.76-35.2 35.2-54.4-55.04 34.56-33.92z"
        fill="currentColor"
        p-id="9780"
      ></path>
      <path
        d="M467.84 631.68H310.4v-27.52H467.2v27.52zM583.68 699.52H310.4V672h273.28v27.52z"
        fill="#6B5FF2"
        p-id="9781"
      ></path>
      <path
        d="M208 257.92h394.24v27.52H235.52v515.2h504.96V491.52h27.52v336H208v-569.6z"
        fill="currentColor"
        p-id="9782"
      ></path>
    </svg>
  ),
  messageEmpty: (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="9922"
    >
      <path
        d="M521.6 216.96L588.8 280.32l-18.56 19.84-49.28-46.08-251.52 224v296.96h484.48V477.44L634.88 363.52l-23.04-23.04 19.2-19.2 23.04 23.04 127.36 122.24v336H242.56V465.28l279.04-248.32z"
        fill="currentColor"
        p-id="9923"
      ></path>
      <path
        d="M515.2 538.24l263.04 234.88-17.92 20.48-245.12-218.88L266.88 793.6l-17.92-20.48 266.24-234.88z"
        fill="currentColor"
        p-id="9924"
      ></path>
      <path
        d="M775.04 480l-179.2 145.28-17.28-21.12 179.2-145.28 17.28 21.12zM247.68 480l179.2 145.28 17.28-21.12-179.2-145.28-17.28 21.12z"
        fill="currentColor"
        p-id="9925"
      ></path>
    </svg>
  ),
  noAvaliable: (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="10065"
    >
      <path
        d="M464 220.8c19.84-16.64 43.52-22.4 60.16-22.4 16 0 39.68 5.12 59.52 20.48 20.48 16 35.84 42.88 35.84 83.2 0 55.68-35.84 83.84-61.44 93.44v37.76l361.6 286.72V793.6H102.4v-73.6l343.04-263.68 16.64 21.76-332.8 255.36v32.64h762.88v-32.64L530.56 446.72V375.04l10.88-2.56c16.64-3.84 50.56-22.4 50.56-70.4 0-32.64-12.16-51.2-25.6-62.08-14.08-10.88-31.36-14.72-42.88-14.72-10.88 0-28.16 4.48-42.24 16-14.08 11.52-25.6 31.36-25.6 64h-27.52c0-40.32 15.36-67.84 35.84-84.48z"
        fill="currentColor"
        p-id="10066"
      ></path>
    </svg>
  ),
  noData: (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="10206"
    >
      <path
        d="M419.84 597.76H283.52v-27.52h136.96v27.52zM752.64 597.76H623.36v-27.52h129.28v27.52z"
        fill="currentColor"
        p-id="10207"
      ></path>
      <path
        d="M419.2 570.88c0 53.12 44.8 97.28 101.12 97.28S620.8 624 620.8 570.88h27.52c0 69.12-57.6 124.8-128 124.8s-128-55.04-128-124.8h26.88z"
        fill="currentColor"
        p-id="10208"
      ></path>
      <path
        d="M387.84 453.76h272.64l108.16 112v223.36h-27.52V576.64l-92.16-95.36h-249.6L307.2 576.64V819.2h464v27.52H279.68V565.76l108.16-112z"
        fill="currentColor"
        p-id="10209"
      ></path>
      <path
        d="M512 263.04h27.52v112.64H512V263.04zM706.56 279.68l24.96 11.52-48 105.6-24.96-11.52 48-105.6zM304 291.84l24.96-11.52 49.28 104.96-24.96 11.52-49.28-104.96z"
        fill="#6B5FF2"
        p-id="10210"
      ></path>
    </svg>
  ),
  cartEmpty: (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="10350"
    >
      <path
        d="M243.84 208H156.8v-27.52h107.52L371.2 578.56h369.92l49.28-215.68H370.56v-27.52h454.4l-62.08 270.08H350.08L243.84 208zM405.76 655.36c-42.24 0-76.8 34.56-76.8 76.8s34.56 76.8 76.8 76.8 76.8-34.56 76.8-76.8-34.56-76.8-76.8-76.8z m0 126.08c-27.52 0-49.28-22.4-49.28-49.28s22.4-49.28 49.28-49.28c27.52 0 49.28 22.4 49.28 49.28s-22.4 49.28-49.28 49.28zM694.4 655.36c-42.24 0-76.8 34.56-76.8 76.8s34.56 76.8 76.8 76.8 76.8-34.56 76.8-76.8-33.92-76.8-76.8-76.8z m0 126.08c-27.52 0-49.28-22.4-49.28-49.28s22.4-49.28 49.28-49.28 49.28 22.4 49.28 49.28-21.76 49.28-49.28 49.28z"
        fill="currentColor"
        p-id="10351"
      ></path>
      <path
        d="M545.92 416.64h27.52v117.76h-27.52V416.64z"
        fill="#6B5FF2"
        p-id="10352"
      ></path>
      <path
        d="M619.52 460.8v27.52H501.76V460.8h117.76z"
        fill="#6B5FF2"
        p-id="10353"
      ></path>
    </svg>
  ),
  noPermission: (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="10493"
    >
      <path
        d="M348.16 442.24h464v346.24H348.16V691.2h27.52v69.76h409.6V469.76h-409.6v113.92h-27.52V442.24z"
        fill="currentColor"
        p-id="10494"
      ></path>
      <path
        d="M701.44 280.32c-31.36-30.72-72.96-48.64-117.12-48.64S497.92 248.96 467.2 280.32c-31.36 30.72-48.64 72.96-48.64 117.12v72.32h331.52V397.44c0-43.52-17.28-85.76-48.64-117.12z m21.12 161.92H445.44v-44.8c0-36.48 14.72-71.68 40.32-97.92 26.24-25.6 61.44-40.32 97.92-40.32 36.48 0 71.68 14.72 97.92 40.32 26.24 25.6 40.32 60.8 40.32 97.92v44.8zM566.4 655.36V570.24h27.52v85.76h-27.52z"
        fill="currentColor"
        p-id="10495"
      ></path>
      <path
        d="M247.68 552.96c-46.08 0-83.84 37.76-83.84 83.84s37.76 83.84 83.84 83.84 83.84-37.76 83.84-83.84-37.76-83.84-83.84-83.84z m0 140.16c-31.36 0-56.32-24.96-56.32-56.32s24.96-56.32 56.32-56.32 56.32 24.96 56.32 56.32c0 30.72-25.6 56.32-56.32 56.32z"
        fill="#6B5FF2"
        p-id="10496"
      ></path>
      <path
        d="M508.8 655.36H307.2v-27.52h201.6v27.52z"
        fill="#6B5FF2"
        p-id="10497"
      ></path>
      <path
        d="M433.28 634.88v-53.12H460.8v53.12h-27.52z"
        fill="#6B5FF2"
        p-id="10498"
      ></path>
    </svg>
  ),
  deleteAccountFailed: (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="10638"
    >
      <path
        d="M392.32 314.24h27.52v51.2h-27.52zM478.08 314.24H505.6v51.2h-27.52z"
        fill="#6B5FF2"
        p-id="10639"
      ></path>
      <path
        d="M447.36 498.56C535.68 498.56 608 427.52 608 339.84S535.68 181.12 447.36 181.12 286.72 252.16 286.72 339.84 358.4 498.56 447.36 498.56z m0-290.56c73.6 0 133.12 58.88 133.12 131.2s-59.52 131.2-133.12 131.2S314.24 411.52 314.24 339.2s59.52-131.2 133.12-131.2zM555.52 542.72H339.2c-41.6 0-81.92 16.64-112 46.08-29.44 29.44-46.08 69.12-46.08 111.36v13.44h359.04c-0.64-8.96-0.64-18.56 0-27.52H208.64c3.2-29.44 16-56.96 37.76-78.08 24.32-24.32 57.6-37.76 92.16-37.76h216.32c13.44 0 26.88 1.92 39.04 5.76 8.32-7.04 17.28-13.44 26.88-19.2-19.84-8.96-42.24-14.08-65.28-14.08z"
        fill="currentColor"
        p-id="10640"
      ></path>
      <path
        d="M686.08 638.08h27.52v71.68h-27.52z"
        fill="#6B5FF2"
        p-id="10641"
      ></path>
      <path
        d="M701.44 570.24c-70.4 0-128 57.6-128 128s57.6 128 128 128 128-57.6 128-128c0-71.04-57.6-128-128-128z m0 228.48c-55.68 0-100.48-44.8-100.48-100.48s44.8-100.48 100.48-100.48 100.48 44.8 100.48 100.48-44.8 100.48-100.48 100.48z"
        fill="#6B5FF2"
        p-id="10642"
      ></path>
      <path
        d="M699.52 723.84c-7.68 0-13.44 6.4-13.44 13.44s6.4 13.44 13.44 13.44c7.68 0 13.44-6.4 13.44-13.44s-5.76-13.44-13.44-13.44z"
        fill="#6B5FF2"
        p-id="10643"
      ></path>
    </svg>
  ),
  paymentSuccessful: (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="10783"
    >
      <path
        d="M376.96 375.04l25.6 9.6-149.12 389.12 392.96-140.8 8.96 25.6L206.72 819.2l170.24-444.16zM647.04 635.52s-0.64 0 0 0c-0.64 0 0 0 0 0z"
        fill="currentColor"
        p-id="10784"
      ></path>
      <path
        d="M556.16 477.44C477.44 398.72 396.8 352 375.68 372.48c-21.12 21.12 25.6 101.76 104.32 180.48 78.72 78.72 159.36 125.44 180.48 104.32 21.12-20.48-25.6-101.12-104.32-179.84z m49.92 142.08C576 601.6 537.6 572.16 499.84 533.76c-38.4-38.4-67.84-76.16-85.12-106.24-7.04-12.8-12.16-23.04-14.08-30.72 7.68 2.56 17.92 7.04 30.72 14.08C460.8 428.8 498.56 458.24 536.96 496.64s67.84 76.16 85.12 106.24c7.04 12.8 12.16 23.04 14.08 30.72-7.04-2.56-17.92-7.04-30.08-14.08zM398.08 386.56s0 0.64 0 0zM389.76 394.88zM638.72 643.2c0 0.64 0 0.64 0 0 0 0.64 0 0.64 0 0z"
        fill="currentColor"
        p-id="10785"
      ></path>
      <path
        d="M673.92 740.48l40.32-46.08 24.32 21.12-40.32 46.08-24.32-21.12zM716.16 453.76l60.8-7.04 3.84 32-60.8 7.04-3.84-32zM565.76 202.88l-9.6 60.16-31.36-5.12 9.6-60.16 31.36 5.12z"
        fill="currentColor"
        p-id="10786"
      ></path>
      <path
        d="M695.68 337.28L625.92 401.92l-21.76-23.68L673.92 313.6l21.76 23.68z"
        fill="#6B5FF2"
        p-id="10787"
      ></path>
      <path
        d="M252.8 350.72l55.04-26.88 14.08 28.8-55.04 26.88-14.08-28.8z"
        fill="currentColor"
        p-id="10788"
      ></path>
      <path
        d="M474.88 341.76c-21.76-37.76-67.84-63.36-108.16-58.88l-3.2-26.88c52.48-5.76 108.16 26.88 135.04 72.32 13.44 23.04 19.84 50.56 14.72 79.36-5.76 28.8-23.04 56.32-54.4 81.28L441.6 467.2c27.52-21.76 40.32-44.16 44.16-64.64 4.48-21.12-0.64-42.24-10.88-60.8zM593.92 563.2c-19.84 6.4-33.92 14.72-39.04 21.12l-20.48-17.92c10.88-12.16 30.08-23.04 51.84-29.44 22.4-7.04 48.64-10.88 74.88-8.96 26.24 1.92 52.48 10.24 73.6 28.8 21.12 18.56 35.84 46.08 39.04 84.48l-27.52 2.56c-3.2-32-14.72-53.12-30.08-65.92-15.36-13.44-35.84-20.48-58.24-21.76-21.76-1.92-44.8 1.28-64 7.04z"
        fill="#6B5FF2"
        p-id="10789"
      ></path>
    </svg>
  ),
};

export const DETAIL_TEXT = {
  actionText: $i18n.get("arise.public.page_info.try_again", "TRY AGAIN"),
  errorNetwork: $i18n.get(
    "arise.public.page_info.error_network",
    "It seems that the network is doing its thing…"
  ),
  error404: $i18n.get(
    "arise.public.page_info.error404",
    "The page you were looking for doesn’t exist"
  ),
  noPermission: $i18n.get(
    "arise.public.page_info.no_permission",
    "It seems you don’t have permission right now. Please let us know so we can fix it"
  ),
  noContent: $i18n.get(
    "arise.public.page_info.no_content",
    "There’s no content here"
  ),
  unknownError: $i18n.get(
    "arise.public.page_info.unknown_error",
    "An unknown error has occurred"
  ),
  noSearchResult: $i18n.get(
    "arise.public.page_info.no_search_result",
    "Sorry, there are no results for your search. Do you want to try again?"
  ),
  noAvaliable: $i18n.get(
    "arise.public.page_info.no_avaliable",
    "This item is no longer avaliable"
  ),
  deleteAccountFailed: $i18n.get(
    "arise.public.page_info.delete_account_failed",
    "We have detected the following problems and your account cannot be deleted"
  ),
  cartEmpty: $i18n.get(
    "arise.public.page_info.cart_empty",
    "Your cart so empty and Arise so full of interesting stuff…"
  ),
  findLove: $i18n.get(
    "arise.public.page_info.find_love",
    "Find hundreds of items that will make you fall in love"
  ),
  errorPay: $i18n.get(
    "arise.public.page_info.error_pay",
    "It seems that the payment couldn’t be made. Please try again"
  ),
  findLoveWithArise: $i18n.get(
    "arise.public.page_info.find_love_with_arise",
    "Explore Arise and save everything you love so you don't lose sight of it."
  ),
  likeAtHand: $i18n.get(
    "arise.public.page_info.like_at_hand",
    "Have everything you like at hand"
  ),
  openOrderNotify: $i18n.get(
    "arise.public.page_info.open_order_notify",
    "Stay updated on order progress by turning on Order Notifications"
  ),
  appearWithChat: $i18n.get(
    "arise.public.page_info.appear_with_chat",
    "As soon as you start a chat it will appear here"
  ),
  newConversation: $i18n.get(
    "arise.public.page_info.new_conversation",
    "Once you start a new conversation, you'll see it listed here."
  ),
  findVoucher: $i18n.get(
    "arise.public.page_info.find_voucher",
    "Find them all on and save on your orders!"
  ),
  hasMoreVoucher: $i18n.get(
    "arise.public.page_info.has_more_voucher",
    "But don't you panic, there's many more on hundreds of items"
  ),
  noRate: $i18n.get(
    "arise.public.page_info.no_rate",
    "Right now you have no item to rate. Do you feel like having a look on Arise?"
  ),
  shareOrder: $i18n.get(
    "arise.public.page_info.share_order",
    "Did you love your last order? Tell it to the world!"
  ),
  thanksShare: $i18n.get(
    "arise.public.page_info.thanks_share",
    "Thanks for sharing your shopping experience"
  ),
  giftForYou: $i18n.get(
    "arise.public.page_info.gift_for_you",
    "So much dedication deserves an award: Here's a gift coupon for you!"
  ),
  successPay: $i18n.get(
    "arise.public.page_info.success_pay",
    "Your payment has been made"
  ),
  somethingWrong: $i18n.get(
    "arise.public.page_info.something_wrong",
    "Oops! Something went wrong."
  ),
};

export interface PageInfoProps {
  /**
   * @description    标题
   * @default    Oops! Something went wrong.
   */
  main?: string;

  /**
   * @description    自定义的详情文案
   * @default
   */
  detail?: string;

  /**
   * @description    通用的详情文案(自带美杜莎翻译),优先级低于detail字段。
   * @default
   */
  detailType?: keyof typeof DETAIL_TEXT;

  /**
   * @description    按钮文本
   * @default    TRY AGAIN
   */
  actionText?: string;

  /**
   * @description    按钮点击的回调
   * @default
   */
  onPress?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;

  /**
   * @description    icon的类型
   * @default    error
   */
  type?: keyof typeof IconMap;

  /**
   * @description    自定义icon的链接，优先级低于type字段
   * @default
   */
  icon?: string;

  /**
   * @description    按钮是否展示
   * @default true
   */
  showAction?: boolean;

  /**
   * @description    按钮与详情文案之间的插槽
   * @default
   */
  children?: ReactElement;

  /**
   * @description    自定义渲染icon
   * @default
   */
  renderCustomIcon?: () => JSX.Element;

  /**
   * @description 插画的布局方式，默认垂直布局。横向布局时，按钮和children失效。
   * @default vertical
   */
  direction?: "vertical" | "horizontal";
}
